import { api } from '@/lib/api';
import type { EquipmentType } from './types';
import type {
  EquipmentTypeCreateValues,
  EquipmentTypeUpdateValues,
} from './schema';

/**
 * Equipment-types REST client over the shared axios instance.
 *
 * Endpoints (Phase 3a):
 *   GET    /equipment-types        list
 *   GET    /equipment-types/:id    detail
 *   POST   /equipment-types        create
 *   PATCH  /equipment-types/:id    update (name/copy/flags only)
 *   DELETE /equipment-types/:id    soft-delete
 */
export const equipmentTypesApi = {
  list: async (): Promise<EquipmentType[]> => {
    const { data } = await api.get<EquipmentType[]>('/equipment-types');
    return data;
  },

  getById: async (id: string): Promise<EquipmentType> => {
    const { data } = await api.get<EquipmentType>(`/equipment-types/${id}`);
    return data;
  },

  create: async (
    input: EquipmentTypeCreateValues,
  ): Promise<EquipmentType> => {
    const { data } = await api.post<EquipmentType>('/equipment-types', input);
    return data;
  },

  update: async (
    id: string,
    patch: EquipmentTypeUpdateValues,
  ): Promise<EquipmentType> => {
    const { data } = await api.patch<EquipmentType>(
      `/equipment-types/${id}`,
      patch,
    );
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/equipment-types/${id}`);
  },
};
